import { render } from "./CancelCoupons.vue?vue&type=template&id=3d852cbb&scoped=true"
import script from "./CancelCoupons.vue?vue&type=script&lang=js"
export * from "./CancelCoupons.vue?vue&type=script&lang=js"

import "./CancelCoupons.vue?vue&type=style&index=0&id=3d852cbb&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d852cbb"]])

export default __exports__